import styled from 'styled-components'

export const ControlContainer = styled.div`
	display: flex;
	align-items: center;
	pointer-events: none;
	margin: -8px -12px;
	flex-shrink: 0;
`
